module.exports = __webpack_public_path__ + "static/img/guandao.82246ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/guandao.jpg
// module id = zLiC
// module chunks = 0